import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import MenuHelper from "../../../../helpers/MenuHelper";
import { NavLink } from "react-router-dom";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import IconTag from "../GetIcon";

const MenuDropdownNav = (props) => {

    return (
        <li className={props?.componentSetting?.["horizonatal-nav-bar"]?.["default-value"]}>
            {(() => {
                const hasSubmenus = Object.values(props.menuList).some((submenu) => submenu.parent_menu_code === props?.v.code);
                if (hasSubmenus || props?.v.location === "sub_menu") {
                    return (
                        <>
                            {!props?.v.parent_menu_code && props?.v.location === "menu" && (
                                <NavLink onMouseOver={() => props?.mouseOver(props?.v.code)} data-dropdown="true"
                                    className={(isActive) => (props?.openDrop == "categories" || props?.openDrop == "transactions") && props?.openDrop == props?.v.code && "active"}
                                    onClick={() =>
                                        props.handleToggleDropdown(props?.v.code)
                                    }
                                >
                                    {
                                        props?.v?.menu_class ? (
                                            <span><IconTag iconTagName={props?.v.menu_class} /></span>
                                        ) : props?.v?.menu_icon ? (
                                            <img
                                                loading="lazy" src={props?.ftpPath + props?.v?.menu_icon?.base_path + props?.v?.menu_icon?.system_file_name}
                                            />
                                        ) :
                                            (props.footerMenu ? <div className="mobile-footer-menu"></div> : null)
                                    }
                                    {props.t(`${props?.v?.name?.toLowerCase()?.replace(/ /g, '_')}`)}
                                    {props?.openDrop === props?.v.code && props?.isDropdownOpen ? (
                                        <IoIosArrowUp className="down-arrow" />
                                    ) : (
                                        <IoIosArrowDown className="down-arrow" />
                                    )}
                                </NavLink>
                            )}
                            {props?.isDropdownOpen && props?.openDrop === props?.v.code && (
                                <div
                                    className="dropdown-content text-menu_dropdown background-menu_dropdown"
                                    ref={props?.dropdownRef}
                                >
                                    {Object.values(props.menuList).map((data, i) => {
                                        const isOpenDropMatches = props?.openDrop === props?.v.code;
                                        const isCategoryDrop = isOpenDropMatches && props?.openDrop === "categories" && data.parent_menu_code === "categories" && data.status;
                                        const isTransactionDrop = isOpenDropMatches && props?.openDrop === "transactions" && data.parent_menu_code === "transactions" && data.status;
                                        const ispromotion = isOpenDropMatches && props?.openDrop === "promotion" && data.parent_menu_code === "promotion" && data.status;
                                        if (isCategoryDrop || isTransactionDrop || ispromotion) {
                                            return (
                                                <NavLink
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        props.handleClose(
                                                            data.code,
                                                            "submenu"
                                                        );
                                                    }}
                                                    to={data.code}
                                                    key={i}
                                                >
                                                    <MenuHelper t={props.t} ftpPath={props?.ftpPath} data={data} className={""} />
                                                </NavLink>
                                            );
                                        }

                                        return null;
                                    }
                                    )}
                                </div>
                            )}
                        </>
                    );
                } else {
                    return (
                        <NavLink to={props.customLink} onClick={() => props.handleClose(props?.v.code)}>
                            <MenuHelper t={props.t} ftpPath={props?.ftpPath} data={props?.v} className={""} />
                        </NavLink>
                    );
                }
            })()}
        </li>
    );
};

MenuDropdownNav.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(MenuDropdownNav);
